'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

exports.default = enhanceProps;

var _enhancers = require('./enhancers');

var _expandAliases = require('./expand-aliases');

var _expandAliases2 = _interopRequireDefault(_expandAliases);

var _styles = require('./styles');

var styles = _interopRequireWildcard(_styles);

var _cache = require('./cache');

var cache = _interopRequireWildcard(_cache);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Converts the CSS props to class names and inserts the styles.
 */


function enhanceProps(rawProps) {
  var propsMap = (0, _expandAliases2.default)(rawProps);
  var enhancedProps = {};
  var className = rawProps.className || '';
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = propsMap[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref = _step.value;

      var _ref2 = _slicedToArray(_ref, 2);

      var propName = _ref2[0];
      var propValue = _ref2[1];
      var cachedClassName = cache.get(propName, propValue);

      if (cachedClassName) {
        className = className + ' ' + cachedClassName;
        continue;
      }

      var enhancer = _enhancers.propEnhancers[propName]; // Skip false boolean enhancers. e.g: `clearfix={false}`
      // Also allows omitting props via overriding with `null` (i.e: neutralising props)

      if (enhancer && (propValue === null || propValue === undefined || propValue === false)) {
        continue;
      } else if (!enhancer) {
        // Pass through native props. e.g: disabled, value, type
        enhancedProps[propName] = propValue;
        continue;
      }

      var newCss = enhancer(propValue); // Allow enhancers to return null for invalid values

      if (newCss) {
        styles.add(newCss.styles);
        cache.set(propName, propValue, newCss.className);
        className = className + ' ' + newCss.className;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  className = className.trim();
  return [className, enhancedProps];
}